export const PATH_API = 'http://10.162.0.32:8000/api'
export const PATH_FILE = 'http://10.162.0.32:8000'